class HttpRequestService {
  static handleUnauthorized(error) {
    if (error.response) {
      if (
        error.response.status === 401 &&
        error.response.data.errorCode === 1
      ) {
        window.location.href = "/login";
      }
    }
  }

  static handleReturnValue(error) {
    const returnObject = {
      message: "خطای ارتباط با سرور",
      status: 408,
      data: {
        message: "خطای ارتباط با سرور",
        data: "خطای ارتباط با سرور",
        status: 408,
      },
    };

    if (!error.response) {
      return returnObject;
    }

    returnObject.status = error.response.status;

    if (typeof error.response.data.data === "string") {
      returnObject.message = error.response.data.data;
    } else {
      returnObject.message =
        error.response.data.message ?? "عملیات با خطا مواجه شد";
    }

    returnObject.data = error.response.data;

    return returnObject;
  }
}

export default HttpRequestService;